import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { BASE_URL } from '../../utils/constants';
import { getErrorMessage } from '../../utils/helper';
const ATTENDANCE_ENDPOINT = 'attendance';

// Fetch Attendance History
export const fetchAttendanceHistory = createAsyncThunk(
  'attendance/fetchHistory',
  async ({ month, year }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}${ATTENDANCE_ENDPOINT}/fetchHistory`, {
        params: { month, year }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch attendance history'));
    }
  }
);

// Fetch Current Attendance
export const fetchCurrentAttendance = createAsyncThunk(
  'attendance/fetchCurrent',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}${ATTENDANCE_ENDPOINT}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch current attendance'));
    }
  }
);

// Punch In
export const punchIn = createAsyncThunk(
  'attendance/punchIn',
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      
      // Append basic data
      formData.append('schoolId', data.schoolId);
      if (data.remark) {
        formData.append('remark', data.remark);
      }
            
      // Append each file individually
      if (data.attachments && data.attachments.length > 0) {
        data.attachments.forEach((file) => {
          formData.append('attachments', file);
        });
      }

      const response = await axiosInstance.post(
        `${BASE_URL}${ATTENDANCE_ENDPOINT}/punchIn`, 
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to punch in'));
    }
  }
);

// Punch Out
export const punchOut = createAsyncThunk(
  'attendance/punchOut',
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      
      // Append basic data
      if (data.remark) {
        formData.append('remark', data.remark);
      }
            
      // Append each file individually
      if (data.attachments && data.attachments.length > 0) {
        data.attachments.forEach((file) => {
          formData.append('attachments', file);
        });
      }

      const response = await axiosInstance.post(`${BASE_URL}${ATTENDANCE_ENDPOINT}/punchOut`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error,'Failed to punch out'));
    }
  }
);

// Fetch Attendance By Date Range
export const fetchAttendanceByDateRange = createAsyncThunk(
  'attendance/fetchByDateRange',
  async ({ startDate, endDate, userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}${ATTENDANCE_ENDPOINT}/dateRange`, {
        params: {
          startDate,
          endDate,
          userId,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch attendance summary'));
    }
  }
);

export const updateAttendance = createAsyncThunk(
  'attendance/updateAttendance',
  async ({ userId, date, attendance }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/attendance/${userId}`, {
        date,
        attendance
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update attendance'));
    }
  }
);

// Approve Attendance
export const approveAttendance = createAsyncThunk(
  'attendance/approve',
  async ({ date, approvalComment, approvalStatus, userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}${ATTENDANCE_ENDPOINT}/approve`, {
        date,
        approvalComment,
        approvalStatus,
        userId
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to approve attendance'));
    }
  }
); 

// Get Attendance by date 
export const getAttendanceByDate = createAsyncThunk(
  'attendance/byDate',
  async ({ date, userId }, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}${ATTENDANCE_ENDPOINT}/byDate?date=${date}`;

      if (userId) url = `${url}&userId=${userId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to approve attendance'));
    }
  }
); 

// Get Presigned URL for Attachment
export const getPresignedUrl = createAsyncThunk(
  'attendance/getPresignedUrl',
  async ({ urls }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}${ATTENDANCE_ENDPOINT}/get-presigned-url`, {
        urls
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to get presigned URL'));
    }
  }
); 